module.exports = __webpack_public_path__ + "img/spain-colorectal-cancer-female.880dc1df.png";